async function generatePlan() {
  const team = document.getElementById("team").value;
  const format = document.getElementById("format").value;
  const collection = document.getElementById("collection").value;
  const module = document.getElementById("module").value;
  const duration = document.getElementById("duration").value;

  const userPrompt = `
Create a high-quality team activity plan using the following details:
Team context: ${team}
Meeting format: ${format}
Collection: ${collection}
Module: ${module || "Use collection only"}
Session type: ${duration}

Follow Skillpod best practices and structure it with activity name, purpose, learning outcomes, materials needed, instructions, reflection, and notes for first-time facilitators. Include basic te reo Māori where appropriate. Keep it to one A4 page.`;

  try {
    const response = await fetch("https://skillpod-word-export.onrender.com/generate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ prompt: userPrompt })
    });

    const data = await response.json();

    if (!data.content) {
      alert("Something went wrong generating your session plan.");
      return;
    }

    const plan = data.content;
    const encodedPlan = encodeURIComponent(plan);
    window.location.href = `https://skillpod.co.nz/pages/team-tools-microsoft-word-download?content=${encodedPlan}`;
  } catch (error) {
    console.error("Error generating session plan:", error);
    alert("There was an issue connecting to the server.");
  }
}
